<template>
  <div>
    <!-- 自定义图标 -->
    <van-popup slot="share"
               v-model="showTag"
               closeable
               close-icon="close"
               round
               @closed="onClosed"
               :style="{width:'90%'}"
    >
      <div class="pl15 pr15 pt30 pb30">
        <h4 class="fs14 color_666">该就诊人在3日内已经开过一下项目：</h4>
        <ul class="mt20">
          <li class="kd-item" v-for="(kd,i) in kdList" :class="{mt10:i}">
            <span class="icon"></span>
            <span class="fs14 color_333">{{ kd.projectName }}</span>
            <span class="tag ml5">自费</span>
          </li>
        </ul>
        <p class="mt20 color_666 fs14">若之前项目仍未支付，<span class="color_red">请不要重复开单</span>(否则可能需要重复付费）。</p>

        <div class="btns pl80 pr80 mt20">
          <van-button type="info" round block @click="onClick('cancel')">查看开单记录</van-button>
          <van-button class="confirmBtn" round block @click="onClick('confirm')">我确定要开单</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>

export default {
  name: "ncp-kdlist-confirm",
  data() {
    return {
      kdList: [],
      showTag: false
    }
  },
  computed: {},
  methods: {
    open() {
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    },
    onClosed() {
      this.$emit('closed', this.type);
    },
    onClick(type) {
      this.type = type;
      this.close()
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../common/public";

.kd-item {
  line-height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;

  .icon {
    width: 4px;
    height: 4px;
    margin-right: 5px;
    border-radius: 2px;
    background-color: $mainColor;
  }

  .tag {
    line-height: 18px;
    color: #FF7824;
    height: 18px;
    text-align: center;
    font-size: 10px;
    background: #FEF4ED;
    width: 35px;
  }
}

.confirmBtn {
  margin-top: 10px;
  color: $mainColor;
  background: #EDF4FF;
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/ncp-kslist-confirm.vue